package com.anjuros.website.templates.template5.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.ResKeyType
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.templates.selection.components.contactform.ContactForm
import com.anjuros.website.templates.selection.components.contactform.ContactFormDetailsType
import com.anjuros.website.templates.selection.components.contactform.ContactFormInfo
import com.anjuros.website.templates.selection.components.contactform.EMAIL_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.NAME_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.NOTE_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.PHONE_NUMBER_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.SuccessContactMessage
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.template1.modules.Template1Theme
import com.anjuros.website.templates.template1.modules.getColor
import com.anjuros.website.templates.template1.modules.getColorOpacity
import com.anjuros.website.templates.template5.components.Template5SectionTitle
import com.anjuros.website.templates.template5.modules.Template5Category
import com.anjuros.website.templates.template5.modules.Template5ContactItem
import com.anjuros.website.templates.template5.modules.Template5HeaderItem
import com.anjuros.website.templates.template5.modules.Template5Product
import com.anjuros.website.templates.template5.modules.Template5Theme
import com.anjuros.website.templates.template5.modules.getColor
import com.anjuros.website.templates.template5.modules.getColorOpacity
import com.anjuros.website.templates.template5.styles.Template5ContactLinkStyle
import com.anjuros.website.templates.template5.styles.Template5ContactSectionStyle
import com.anjuros.website.templates.template5.util.ResKey
import com.anjuros.website.templates.template5.util.Template5Constants
import com.anjuros.website.templates.template5.util.Template5ObserverViewportEntered
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text


@Composable
fun Template5ContactSection() {


    Column(
        modifier = Template5ContactSectionStyle.toModifier()
            .id(Template5HeaderItem.CONTACT.id)
            .fillMaxWidth()
            .backgroundColor(Template5Theme.Background.getColorOpacity()),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {

        Template5SectionTitle(
            badge = ResKey.TEMPLATE5_CONTACT_BADGE,
            title = ResKey.TEMPLATE5_CONTACT_TITLE,
            text = ResKey.TEMPLATE5_CONTACT_SUBTITLE
        )

        Spacer()


            Row(
                modifier = Modifier.displayIfAtLeast(Breakpoint.LG)
                    .fillMaxWidth(80.percent),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.Top
            ) {

                Template5ContactInfo(modifier = Modifier.margin(right = 35.px))

                Template5ContactFormCard(modifier = Modifier.margin(left = 35.px))

            }


            Column(
                modifier = Modifier.displayUntil(Breakpoint.LG)
                    .fillMaxWidth()
                    .maxWidth(650.px),
                verticalArrangement = Arrangement.spacedBy(36.px)
            ) {

                Template5ContactInfo()

                Template5ContactFormCard()

            }

    }

}

@Composable
private fun Template5ContactInfo(modifier: Modifier = Modifier) {

    val animatedOpacity = remember {
        mutableStateOf(0.0f)
    }
    Template5ObserverViewportEntered(
        sectionId = "contactInfo",
        distanceFromTop = 400.0
    ) {

        animatedOpacity.value = 1.0f
    }


    Column(
        modifier = modifier.fillMaxWidth().maxWidth(340.px)
            .id("contactInfo")
    ) {

        Template5ContactIntro()

        Template5ContactItem.entries.forEach { template5ContactItem ->
            Template5ContactItemCard(
                template5ContactItem = template5ContactItem,
                opacity = animatedOpacity.value
            )

        }

    }

}

@Composable
private fun Template5ContactItemCard(
    template5ContactItem: Template5ContactItem,
    opacity:Float
) {

    Row(
        modifier = Modifier.margin(topBottom = 5.px)
            .opacity(opacity)
            .transition(Transition.of(
                "opacity",
                600.ms,
                delay = template5ContactItem.ordinal*600.ms
            )),
        verticalAlignment = Alignment.CenterVertically
    ) {

        Box(
            modifier = Modifier
                .size(56.px)
                .borderRadius(50.percent)
                .backgroundColor(rgb(255, 240, 242)),
            contentAlignment = Alignment.Center
        ) {

            Image(
                modifier = Modifier.size(22.px),
                src = template5ContactItem.icon,
                alt = LocalText(template5ContactItem.title)
            )

        }

        val details: @Composable () -> Unit = {
            Column(
                modifier = Template5ContactLinkStyle.toModifier().margin(left = 18.px)
            ) {

                Span(
                    attrs = Modifier
                        .fontSize(15.px)
                        .fontWeight(FontWeight.SemiBold)
                        .color(Template5Theme.Primary.getColor())
                        .toAttrs()
                ) {
                    Text(LocalText(template5ContactItem.title))
                }

                Span(
                    attrs = Modifier
                        .id("contactValue")
                        .fontSize(17.px)
                        .color(rgb(95, 95, 95))
                        .margin(top = 4.px)
                        .toAttrs()
                ) {
                    AnjurosText(template5ContactItem.value)
                }

            }
        }
        // Items without an address (like the collection area) are plain text, not a link.
        if (template5ContactItem.path.isEmpty()) {
            details()
        } else {
            Link(
                path = template5ContactItem.path,
                modifier = Modifier.textDecorationLine(TextDecorationLine.None).cursor(Cursor.Pointer)
            ) { details() }
        }

    }
    Spacer()
}

@Composable
private fun Template5ContactFormCard(modifier: Modifier = Modifier) {

    Box(
        modifier = modifier
            .borderRadius(32.px)
            .backgroundColor(Colors.White)
            .padding(topBottom = 10.px, leftRight = 25.px)
            .border(
                width = 1.px,
                color = Template5Theme.Primary.rgb,
                style = LineStyle.Solid
            )
            .boxShadow(
                offsetY = 20.px,
                blurRadius = 60.px,
                color = rgba(0,0,0,.3)
            )
    ) {

        Template5ContactBox(
            showBorder = false
        )

    }

}

@Composable
private fun Template5ContactIntro() {

    Column {


        P(
            attrs = Modifier
                .fontSize(35.px)
                .color(Template5Theme.Primary.getColor())
                .whiteSpace(WhiteSpace.PreLine)
                .fontFamily(Template5Constants.FONT_FAMILY_CRAFT)
                .margin(top = 30.px, bottom = 10.px)
                .maxWidth(620.px)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE5_CONTACT_CARD_TITLE))
        }
        Spacer()

        P(
            attrs = Modifier
                .fontSize(18.px)
                .lineHeight(1.9)
                .color(rgb(95, 95, 95))
                .margin(bottom = 40.px)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE5_CONTACT_CARD_TEXT))
        }

    }

}


@Composable
fun Template5ContactBox( modifier: Modifier = Modifier.fillMaxWidth(),
                         showBorder:Boolean) {
    var success by remember { mutableStateOf(false) }


    Box(
        modifier = modifier
            .margin(topBottom =5.px)
            .thenIf(showBorder,Modifier.margin(topBottom =50.px)
                .padding(30.px)
                .position(Position.Relative)
                .border(
                    width = 1.px,
                    color = Theme.DarkGrey.rgb,
                    style = LineStyle.Solid
                ).boxShadow(
                    2.px, 2.px, 5.0.px, 1.0.px, color = Theme.DarkGrey.rgb, false
                )
                .borderRadius(5.px))
           ,
        contentAlignment = Alignment.Center
    ) {


        ContactForm(
            isDemo = true,
            buttonColor = Template5Theme.Primary.getColor(),
            spamProtectionBackgroundColor = Template5Theme.Primary.getColor(),
            spamProtectionColor = Template5Theme.LightGray.rgb,
            spamShieldColor = "#EDEDED",
            contactItemsList = listOf(
                NAME_CONTACT_FORM.copy(index = 0),
                PHONE_NUMBER_CONTACT_FORM.copy(index = 1),
                EMAIL_CONTACT_FORM.copy(index = 2,
                    required = false,
                    validations = listOf()
                ),
                ContactFormInfo(
                    type = ContactFormDetailsType.DROP_DOWN_LINKED,
                    placeholderText = ResKey.CONTACT_DROP1_PLACEHOLDER,
                    labelText = ResKey.CONTACT_DROP1_LABEL,
                    nameText = "Cake",

                    linkedOptionList = getLinkedProductList(),
                    required = false,
                    index = 3
                ),
                NOTE_CONTACT_FORM.copy(index = 4),
            )
        ) {
            success = true
        }
        SuccessContactMessage(
            isDemo = true,
            showSuccess = success,
            onClose = { success = false }
        )
    }
}

fun getLinkedProductList(): Map<ResKeyType, List<ResKeyType>> {

    val productsBySubtype = Template5Product.entries
        .groupBy { it.category }

    val map: MutableMap<ResKeyType, List<ResKeyType>> =
        Template5Category.entries.associate { mainType ->
            mainType.title as ResKeyType to (
                    productsBySubtype[mainType]
                        ?.map { it.title as ResKeyType }
                        ?: emptyList()
                    )
        }.toMutableMap()

    map[ResKey.CONTACT_DROP_OTHER] = emptyList()

    return map
}